(() => {
  if (window.treviCategoryShoppingLoaded) return;
  window.treviCategoryShoppingLoaded = true;
  function initializeLoop(rail) {
    if (rail.treviResetLoop) return;
    const originals = [...rail.children];
    if (originals.length < 2) return;
    const cloneCard = card => {
      const copy = card.cloneNode(true);
      copy.dataset.treviLoopCopy = 'true';
      copy.querySelectorAll('img').forEach(image => { image.loading = 'eager'; image.decoding = 'async'; });
      // Cloned forms remain usable without duplicating document IDs.
      copy.querySelectorAll('[id]').forEach(el => el.removeAttribute('id'));
      copy.querySelectorAll('[for]').forEach(el => el.removeAttribute('for'));
      return copy;
    };
    rail.prepend(...originals.map(cloneCard));
    rail.append(...originals.map(cloneCard));
    const center = card => card.getBoundingClientRect().left - rail.getBoundingClientRect().left + rail.scrollLeft - (rail.clientWidth - card.offsetWidth) / 2;
    let resetting = false;
    rail.treviResetLoop = () => {
      if (!rail.clientWidth) return;
      resetting = true;
      rail.scrollLeft = center(originals[0]);
      requestAnimationFrame(() => { resetting = false; });
    };
    rail.tabIndex = 0;
    rail.setAttribute('aria-label', 'Collection products');
    rail.addEventListener('keydown', event => {
      if (event.target !== rail || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault();
      const step = center(originals[1]) - center(originals[0]);
      rail.scrollLeft += event.key === 'ArrowRight' ? step : -step;
    });
    let settleTimer, pointerDown = false;
    const normalizeLoop = () => {
      if (resetting || pointerDown || !rail.clientWidth) return;
      const start = center(originals[0]);
      const cycle = center(rail.children[originals.length * 2]) - start;
      const step = cycle / originals.length;
      let offset = 0;
      if (rail.scrollLeft < start - step / 2) offset = cycle;
      else if (rail.scrollLeft >= start + cycle - step / 2) offset = -cycle;
      if (!offset) return;
      // Rebase identical tiles only after momentum/snap has settled.
      // Disable snap briefly so the invisible jump cannot animate backwards.
      resetting = true;
      rail.style.scrollSnapType = 'none';
      rail.scrollLeft += offset;
      requestAnimationFrame(() => requestAnimationFrame(() => {
        rail.style.removeProperty('scroll-snap-type');
        resetting = false;
      }));
    };
    rail.addEventListener('pointerdown', () => { pointerDown = true; });
    const release = () => { pointerDown = false; clearTimeout(settleTimer); settleTimer = setTimeout(normalizeLoop, 180); };
    rail.addEventListener('pointerup', release);
    rail.addEventListener('pointercancel', release);
    rail.addEventListener('scroll', () => {
      clearTimeout(settleTimer);
      settleTimer = setTimeout(normalizeLoop, 180);
    }, {passive:true});
    let previousWidth = 0;
    new ResizeObserver(() => {
      // Image loading can change height; never reset the user's swipe for that.
      if (rail.clientWidth && rail.clientWidth !== previousWidth) {
        previousWidth = rail.clientWidth;
        rail.treviResetLoop();
      }
    }).observe(rail);
  }
  function initialize(root = document) {
    root.querySelectorAll("[data-trevi-find-flavor] .trevi-product-rail").forEach(rail => { initializeLoop(rail); rail.treviResetLoop?.(); });
    root.querySelectorAll('[data-trevi-tabs]').forEach(section => {
      if (section.dataset.initialized) return;
      section.dataset.initialized = 'true';
      const tabs = [...section.querySelectorAll('[role="tab"]')];
      const select = tab => {
        tabs.forEach(item => {
          const active = item === tab;
          item.setAttribute('aria-selected', String(active));
          item.tabIndex = active ? 0 : -1;
          const panel = document.getElementById(item.getAttribute('aria-controls'));
          if (panel) panel.hidden = !active;
          if (active && panel) panel.querySelectorAll('.trevi-product-rail').forEach(rail => { initializeLoop(rail); rail.treviResetLoop?.(); });
        });
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => select(tab));
        tab.addEventListener('keydown', event => {
          let target;
          if (event.key === 'ArrowRight') target = tabs[(index + 1) % tabs.length];
          if (event.key === 'ArrowLeft') target = tabs[(index - 1 + tabs.length) % tabs.length];
          if (event.key === 'Home') target = tabs[0];
          if (event.key === 'End') target = tabs[tabs.length - 1];
          if (target) { event.preventDefault(); select(target); target.focus(); }
        });
      });
      if (tabs.length) select(tabs[0]);
    });
    root.querySelectorAll('[data-trevi-categories]').forEach(group => {
      if (group.dataset.initialized) return;
      group.dataset.initialized = 'true';
      const categories = [...group.querySelectorAll('.trevi-category')];
      categories.forEach(category => {
        const summary = category.querySelector('summary');
        const previewCategory = () => {
          if (!group.classList.contains('trevi-categories--desktop')) return;
          categories.forEach(other => { other.open = other === category; });
        };
        summary.addEventListener('pointerenter', event => {
          if (event.pointerType === 'mouse' && window.matchMedia('(hover: hover) and (min-width: 1024px)').matches) previewCategory();
        });
        summary.addEventListener('focus', previewCategory);
        summary.addEventListener('click', event => {
          if (category.open && group.classList.contains('trevi-categories--desktop')) event.preventDefault();
          else categories.forEach(other => { if (other !== category) other.open = false; });
        });
      });
    });
  }
  document.addEventListener('click', event => {
    document.querySelectorAll('.trevi-shop-menu[open]').forEach(menu => { if (!menu.contains(event.target)) menu.open = false; });
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelectorAll('.trevi-shop-menu[open]').forEach(menu => { menu.open = false; menu.querySelector('summary').focus(); });
  });
  document.addEventListener('change', event => {
    if (!event.target.matches('.trevi-quick-add select')) return;
    const card = event.target.closest('.trevi-shop-card');
    const price = card.querySelector('[data-trevi-price]');
    if (price) price.textContent = event.target.selectedOptions[0].dataset.price;
  });

  document.addEventListener('shopify:section:load', event => initialize(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
})();
